import React, { useEffect } from 'react';
import './App.css';
import MainContainer from './containers/MainContainer';
import Layout from './layouts/MainLayout.jsx';
import { initParentPageListener } from './utils/parentPageListener';

function App() {
  // Initialize listener for parent page data
  useEffect(() => {
    initParentPageListener();
  }, []);

  // const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || "";

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const sendToIntercom =
  //     (params.get("send_to_intercom") || "").toLowerCase() === "true";

  //   if (sendToIntercom && INTERCOM_APP_ID) {
  //     window.intercomSettings = { app_id: INTERCOM_APP_ID };
  //     (function () {
  //       var w = window;
  //       var ic = w.Intercom;
  //       if (typeof ic === "function") {
  //         ic("reattach_activator");
  //         ic("update", window.intercomSettings);
  //       } else {
  //         var d = document;
  //         var i = function () {
  //           i.c(arguments);
  //         };
  //         i.q = [];
  //         i.c = function (args) {
  //           i.q.push(args);
  //         };
  //         w.Intercom = i;
  //         var l = function () {
  //           var s = d.createElement("script");
  //           s.type = "text/javascript";
  //           s.async = true;
  //           // ✅ use the variable here
  //           s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
  //           var x = d.getElementsByTagName("script")[0];
  //           x.parentNode.insertBefore(s, x);
  //         };
  //         if (w.attachEvent) {
  //           w.attachEvent("onload", l);
  //         } else {
  //           w.addEventListener("load", l, false);
  //         }
  //       }
  //     })();
  //   }
  // }, [INTERCOM_APP_ID]);

  return (
    <Layout>
      <MainContainer />
    </Layout>
  );
}

export default App;
